/**
 * Users with settings.manage_lookups but without staff/roles admin permissions
 * get a reduced Settings sidebar and route access (lookup editor / support staff).
 */

const BROAD_SETTINGS_STAFF_PERMS = [
  'settings.manage_roles',
  'settings.assign_roles',
  'settings.manage_staff',
];

/** Route segments under /:tenant/settings/:segment allowed for lookup-only users (client + referral + provider lookups). */
export const SETTINGS_LOOKUP_ONLY_TABLE_IDS = [
  'counties',
  'cities',
  'languages',
  'races',
  'living-arrangements',
  'insurance-companies',
  'insurance-types',
  'referral-level-1',
  'referral-level-2',
  'diagnosis-autoeligible',
  'termination-reasons',
  'provider-types',
  'credential-codes',
  'service-areas',
  'frequencies',
  'delay-reasons',
];

const LOOKUP_ONLY_SET = new Set(SETTINGS_LOOKUP_ONLY_TABLE_IDS);

/**
 * Lookup editor: can manage dictionary tables but is not a tenant staff/roles admin.
 */
export function isSettingsLookupOnlyNav(permissions) {
  if (!Array.isArray(permissions) || !permissions.includes('settings.manage_lookups')) {
    return false;
  }
  return !BROAD_SETTINGS_STAFF_PERMS.some((p) => permissions.includes(p));
}

export function isLookupOnlyAllowedTableSegment(segment) {
  if (segment === '' || segment == null) return true;
  return LOOKUP_ONLY_SET.has(segment);
}

/**
 * First path segment after .../settings (e.g. insurance-companies).
 * Returns '' for /settings or /settings/ only; null if path has no /settings.
 */
export function getFirstSettingsRouteSegment(pathname) {
  if (typeof pathname !== 'string') return null;
  const idx = pathname.indexOf('/settings');
  if (idx === -1) return null;
  const after = pathname.slice(idx + '/settings'.length);
  if (after === '' || after === '/') return '';
  const withoutLeading = after.replace(/^\//, '');
  const segment = withoutLeading.split('/')[0];
  return segment || '';
}
